import React, { useEffect, useState } from 'react';

import amWarning from '../../../../assets/img/accountmanagement/am-warning.svg';

import tickIcon from '../../../../assets/img/tick.svg';
import closeIcon from '../../../../assets/img/delete.svg';

import styles from './AccountManagementAddEditPopup.module.css';

import BasicSettings from './components/BasicSettings/BasicSettings';
import Loader from '../../../../campaigns/components/Loader/Loader';
import TabSelector from './components/TabSelector/TabSelector';
import { AccountManagementAddEditPopupTabs } from '../../helpers/constants';
import AccessToCommunity from './components/AccessToCommunity/AccessToCommunity';

const ObjectID = require('bson-objectid');

export default ({
  level,
  parent = null,
  invitationParent = null,
  activePopup,
  title,
  subtitle1,
  subtitle2,
  label1,
  inviteText,
  onSubmit,
  onClose,
  submitLoading,
  invitationType,
  refetchList,
  setActivePopup,
  higherRecords,
  isAdmin,
  validate = () => true,
  defaultConstants
}) => {
  const defaultPermissions = {
    questionsPerSurveyIncludedInLicence:
      defaultConstants.accountManagementDefaultPermissionValues
        .NUMBER_OF_QUESTIONS_INCLUDED_IN_LICENCE,
    sampleSizeIncludedInLicence:
      defaultConstants.accountManagementDefaultPermissionValues
        .SAMPLE_SIZE_INCLUDED_IN_LICENCE,
    incidenceRateIncludedInLicence:
      defaultConstants.accountManagementDefaultPermissionValues
        .INCIDENCE_RATE_INCLUDED_IN_LICENCE
  };

  const [internalRecord, setInternalRecord] = useState(
    activePopup && activePopup.record
      ? { ...activePopup.record, level, parent }
      : {
          level,
          parent,
          id: ObjectID().toString(),
          permissions: defaultPermissions
        }
  );
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(
    AccountManagementAddEditPopupTabs.BASIC_SETTINGS
  );

  const isValid = validate(internalRecord);

  const parentRecordInformation =
    higherRecords && higherRecords.find(r => r.id === parent);
  const parentWithLicence =
    parentRecordInformation && parentRecordInformation.licenceEndDate;

  useEffect(
    () => {
      if (
        internalRecord &&
        internalRecord.creditsAllocated === null &&
        internalRecord.creditsLeft === 0
      ) {
        setError('Licence expired');
      } else {
        setError(null);
      }
    },
    [internalRecord.creditsAllocated]
  );

  const setInternalRecordAction = r => {
    setInternalRecord(r);

    if (r.creditsLeft < 0) {
      setError('The credits left must not be a negative number');
    } else if (
      internalRecord &&
      internalRecord.creditsAllocated === null &&
      internalRecord.creditsLeft === 0
    ) {
      setError('Licence expired');
    } else {
      setError(null);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      {isAdmin ? (
        <TabSelector
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          options={[
            {
              label: 'Basic settings',
              value: AccountManagementAddEditPopupTabs.BASIC_SETTINGS
            },
            {
              label: 'Access to community',
              value: AccountManagementAddEditPopupTabs.ACCESS_TO_COMMUNITY
            }
            /* ,
              {
                label: 'Access to technology',
                value: AccountManagementAddEditPopupTabs.ACCESS_TO_TECHNOLOGY
              }
              */
          ]}
        />
      ) : null}
      {activeTab === AccountManagementAddEditPopupTabs.BASIC_SETTINGS && (
        <BasicSettings
          level={level}
          subtitle1={subtitle1}
          subtitle2={subtitle2}
          label1={label1}
          inviteText={inviteText}
          internalRecord={internalRecord}
          setInternalRecord={r => setInternalRecordAction(r)}
          activePopup={activePopup}
          invitationParent={invitationParent}
          invitationType={invitationType}
          parentWithLicence={parentWithLicence}
          defaultConstants={defaultConstants}
        />
      )}
      {activeTab === AccountManagementAddEditPopupTabs.ACCESS_TO_COMMUNITY && (
        <AccessToCommunity
          internalRecord={internalRecord}
          setInternalRecord={r => setInternalRecordAction(r)}
          activePopup={activePopup}
        />
      )}
      {error ? (
        <div className={styles.errorContainer}>
          <img
            className={styles.warningErrorIcon}
            alt="Touchpoints tooltip"
            src={amWarning}
          />
          {error}
        </div>
      ) : null}
      <div className={styles.footer}>
        <div />
        <div className={styles.actions}>
          {submitLoading && (
            <div className={styles.loaderContainer}>
              <Loader size="small" />
            </div>
          )}
          {!submitLoading && [
            isValid ? (
              <img
                key="submit-button"
                className={`${
                  styles.confirm
                } workspaces-manage-workspace-confirm-button`}
                src={tickIcon}
                alt="Confirm icon"
                onClick={async () => {
                  const processedInternalRecord = { ...internalRecord };
                  if (
                    processedInternalRecord &&
                    processedInternalRecord.managers
                  ) {
                    processedInternalRecord.managers = processedInternalRecord.managers.map(
                      m => m.id
                    );
                  }

                  if (processedInternalRecord.permissions) {
                    delete processedInternalRecord.permissions.__typename;
                  }

                  const res = await onSubmit({
                    variables: processedInternalRecord
                  });

                  const actionPath =
                    activePopup && activePopup.record
                      ? 'updateAccountManagementRecord'
                      : 'createAccountManagementRecord';

                  if (
                    res &&
                    res.data &&
                    res.data[actionPath] &&
                    res.data[actionPath].done
                  ) {
                    setActivePopup(null);
                    await refetchList();
                  }

                  if (
                    res &&
                    res.data &&
                    res.data[actionPath] &&
                    !res.data[actionPath].done
                  ) {
                    if (
                      res.data[actionPath].errors &&
                      res.data[actionPath].errors.length
                    ) {
                      setError(res.data[actionPath].errors[0].message);
                    }
                  }
                }}
                role="presentation"
              />
            ) : (
              <img
                key="submit-button"
                className={`${styles.confirm} ${
                  styles.invalid
                } workspaces-manage-workspace-confirm-button`}
                src={tickIcon}
                alt="Confirm icon"
              />
            ),
            <img
              key="close-button"
              className={styles.close}
              src={closeIcon}
              alt="Close icon"
              onClick={() => onClose()}
              role="presentation"
            />
          ]}
        </div>
      </div>
    </div>
  );
};
